import { Component, ElementRef, HostBinding, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';

import { AnalyticsService } from '../../../services/analytics.service';
import { CustomerHelpService } from '../../../services/customer-help.service';
import { ComplaintMessage } from '../../../models/customer-help';
import { TextareaCounterComponent } from '../../textarea-counter/textarea-counter.component';
import { WindowRef } from '../../../services/windowRef';

@Component({
  selector: '[data-component=complaint-form]',
  templateUrl: './complaint-form.component.html',
})
export class ComplaintFormComponent {
  @HostBinding('class.complaint-form') isComplaintForm = true;
  @ViewChild('textarea') textarea: TextareaCounterComponent;
  public complaintForm: FormGroup;
  public formDirty: boolean = false;
  public isSubmitting: boolean = false;
  public submitted: boolean = false;
  public submitError: boolean = false;
  public errorMessage: string;

  constructor(
    private analyticsService: AnalyticsService,
    public customerHelpService: CustomerHelpService,
    public elementRef: ElementRef,
    public windowRef: WindowRef
  ) {}

  ngOnInit() {
    this.complaintForm = new FormGroup({
      preferredTimeToCall8to12: new FormControl('', []),
      preferredTimeToCall12to16: new FormControl('', []),
      preferredTimeToCall16to19: new FormControl('', []),
      message: new FormControl('', [Validators.required]),
    });
  }

  submitComplaint() {
    this.formDirty = true;
    if (!this.complaintForm.valid || !this.preferredTimeToCallSelected())
      return;

    this.isSubmitting = true;
    this.submitted = false;
    this.submitError = false;

    const preferredTimeToCall = this.getPreferredTimeToCall();
    const message = this.complaintForm.controls['message'].value;
    const data = new ComplaintMessage(preferredTimeToCall, message);

    this.analyticsService.pushToDataLayer({
      preferredCallTime: preferredTimeToCall,
      event: 'gaEvent',
    });

    this.customerHelpService
      .postComplaintForm(data)
      .then(() => {
        this.submitError = false;
        this.scrollToTop();
      })
      .catch((err) => {
        this.errorMessage =
          err.status === 403 && err.error.data
            ? err.error.data
            : 'System currently unavailable, please try again.';
        this.submitError = true;
      })
      .then(() => {
        this.isSubmitting = false;
        this.submitted = true;
      });
  }

  hasError(field: string): boolean {
    const dirty =
      field == 'message'
        ? this.textarea != null && this.textarea.isDirty
        : this.complaintForm.controls[field].dirty;
    return (
      this.complaintForm != null &&
      this.complaintForm.controls[field].invalid &&
      (dirty || this.complaintForm.controls[field].touched || this.formDirty)
    );
  }

  preferredTimeToCallSelected(): boolean {
    if (this.complaintForm == null || !this.formDirty) return true;

    return this.getPreferredTimeToCall().length != 0;
  }

  private scrollToTop(): void {
    const yPos = this.elementRef.nativeElement.offsetTop - 20;
    this.windowRef.scrollTo(0, yPos);
  }

  private getPreferredTimeToCall(): string {
    if (this.complaintForm == null) return '';

    let prefferedTime = this.complaintForm.controls['preferredTimeToCall8to12']
      .value
      ? '08:00 - 12:00,'
      : '';
    prefferedTime += this.complaintForm.controls['preferredTimeToCall12to16']
      .value
      ? '12:00 - 16:00,'
      : '';
    prefferedTime += this.complaintForm.controls['preferredTimeToCall16to19']
      .value
      ? '16:00 - 19:00,'
      : '';

    return prefferedTime.length == 0
      ? ''
      : prefferedTime.substring(0, prefferedTime.length - 1);
  }
}
